// extracted by css-extract-rspack-plugin
export default {"Spinner":"MQ_qvvVoYz0t2tnl","fadeIn":"FZFdVvWlHdE5Gyl6"};